<template>
    
        
        <v-btn @click="back" color="blue-grey" outlined class="ma-2"><v-icon color="#7B96A3">mdi-arrow-left</v-icon>{{ text }}</v-btn>

  </template>
  
  <script>
  import { Link } from '@inertiajs/inertia-vue'
  
  export default {
    props: {
      href: String,
      text: {
        type: String,
        default: 'Back'
      }
    },
    components: {
      Link
    },
    methods: {
      back() {
        window.history.back();
      },
    }
  }
  </script>
  